/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type RecipesPage_allRecipes$ref = any;
export type RecipesPagePaginationQueryVariables = {|
  count?: ?number,
  cursor?: ?string,
  name?: ?string,
  category?: ?string,
  orderBy?: ?$ReadOnlyArray<?string>,
  author?: ?string,
  publicDateFrom?: ?string,
  publicDateTo?: ?string,
  isTrend?: ?boolean,
|};
export type RecipesPagePaginationQueryResponse = {|
  +$fragmentRefs: RecipesPage_allRecipes$ref
|};
export type RecipesPagePaginationQuery = {|
  variables: RecipesPagePaginationQueryVariables,
  response: RecipesPagePaginationQueryResponse,
|};
*/


/*
query RecipesPagePaginationQuery(
  $count: Int
  $cursor: String
  $name: String
  $category: ID
  $orderBy: [String]
  $author: ID
  $publicDateFrom: String
  $publicDateTo: String
  $isTrend: Boolean
) {
  ...RecipesPage_allRecipes_1fquU1
}

fragment RecipesPage_allRecipes_1fquU1 on Query {
  allRecipes(name: $name, first: $count, after: $cursor, orderBy: $orderBy, category: $category, author: $author, publicDateFrom: $publicDateFrom, publicDateTo: $publicDateTo, isTrend: $isTrend) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        isTrend
        name
        category {
          id
          name
        }
        serves
        favoritedBy {
          edges {
            node {
              username
              id
            }
          }
        }
        medRatings
        totalRatings
        published
        hotKeep
        picture
        difficulty
        description
        labels {
          edges {
            node {
              id
              name
            }
          }
        }
        mediaFiles {
          edges {
            node {
              id
              mediaUrl
            }
          }
        }
        __typename
      }
      cursor
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "category",
    "type": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orderBy",
    "type": "[String]"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "author",
    "type": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "publicDateFrom",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "publicDateTo",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isTrend",
    "type": "Boolean"
  }
],
v1 = {
  "kind": "Variable",
  "name": "author",
  "variableName": "author"
},
v2 = {
  "kind": "Variable",
  "name": "category",
  "variableName": "category"
},
v3 = {
  "kind": "Variable",
  "name": "isTrend",
  "variableName": "isTrend"
},
v4 = {
  "kind": "Variable",
  "name": "name",
  "variableName": "name"
},
v5 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v6 = {
  "kind": "Variable",
  "name": "publicDateFrom",
  "variableName": "publicDateFrom"
},
v7 = {
  "kind": "Variable",
  "name": "publicDateTo",
  "variableName": "publicDateTo"
},
v8 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v1/*: any*/),
  (v2/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = [
  (v9/*: any*/),
  (v10/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RecipesPagePaginationQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "RecipesPage_allRecipes"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RecipesPagePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": "RecipeNodeConnection",
        "kind": "LinkedField",
        "name": "allRecipes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecipeNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isTrend",
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecipeCategoryNode",
                    "kind": "LinkedField",
                    "name": "category",
                    "plural": false,
                    "selections": (v11/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "serves",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserNodeConnection",
                    "kind": "LinkedField",
                    "name": "favoritedBy",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "username",
                                "storageKey": null
                              },
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "medRatings",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRatings",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "published",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hotKeep",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "picture",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "difficulty",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LabelNodeConnection",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LabelNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LabelNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v11/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecipeMediaNodeConnection",
                    "kind": "LinkedField",
                    "name": "mediaFiles",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RecipeMediaNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RecipeMediaNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "mediaUrl",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v8/*: any*/),
        "filters": [
          "name",
          "orderBy",
          "category",
          "author",
          "publicDateFrom",
          "publicDateTo",
          "isTrend"
        ],
        "handle": "connection",
        "key": "Recipes_allRecipes",
        "kind": "LinkedHandle",
        "name": "allRecipes"
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "RecipesPagePaginationQuery",
    "operationKind": "query",
    "text": "query RecipesPagePaginationQuery(\n  $count: Int\n  $cursor: String\n  $name: String\n  $category: ID\n  $orderBy: [String]\n  $author: ID\n  $publicDateFrom: String\n  $publicDateTo: String\n  $isTrend: Boolean\n) {\n  ...RecipesPage_allRecipes_1fquU1\n}\n\nfragment RecipesPage_allRecipes_1fquU1 on Query {\n  allRecipes(name: $name, first: $count, after: $cursor, orderBy: $orderBy, category: $category, author: $author, publicDateFrom: $publicDateFrom, publicDateTo: $publicDateTo, isTrend: $isTrend) {\n    totalCount\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      node {\n        id\n        isTrend\n        name\n        category {\n          id\n          name\n        }\n        serves\n        favoritedBy {\n          edges {\n            node {\n              username\n              id\n            }\n          }\n        }\n        medRatings\n        totalRatings\n        published\n        hotKeep\n        picture\n        difficulty\n        description\n        labels {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        mediaFiles {\n          edges {\n            node {\n              id\n              mediaUrl\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '30798ca786dfb5972706f8aa6cdc8a23';

module.exports = node;
